/** HTML date input(`YYYY-MM-DD`)용 값 정규화 */

const pad2 = (n) => String(n).padStart(2, '0');

const isValidYmdParts = (year, month, day) => {
    const y = Number(year);
    const m = Number(month);
    const d = Number(day);
    if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) {
        return false;
    }
    if (m < 1 || m > 12 || d < 1 || d > 31) {
        return false;
    }
    const dt = new Date(y, m - 1, d);
    return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d;
};

const toYmdString = (year, month, day) => `${year}-${pad2(month)}-${pad2(day)}`;

/** 260325 → 2026-03-25 (YY+MM+DD 6자리) */
const parseYyMmDdDigits = (digits) => {
    const d = String(digits || '').trim();
    if (!/^\d{6}$/.test(d)) {
        return '';
    }
    const yy = Number(d.slice(0, 2));
    const month = Number(d.slice(2, 4));
    const day = Number(d.slice(4, 6));
    const year = 2000 + yy;
    if (!isValidYmdParts(year, month, day)) {
        return '';
    }
    return toYmdString(year, month, day);
};

/** 20260325 → 2026-03-25 */
const parseYyyyMmDdDigits = (digits) => {
    const d = String(digits || '').trim();
    if (!/^\d{8}$/.test(d)) {
        return '';
    }
    const year = Number(d.slice(0, 4));
    const month = Number(d.slice(4, 6));
    const day = Number(d.slice(6, 8));
    if (!isValidYmdParts(year, month, day)) {
        return '';
    }
    return toYmdString(year, month, day);
};

export const toHtmlDateValue = (raw) => {
    const s = String(raw ?? '').trim();
    if (!s) {
        return '';
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        return s;
    }
    const dotted4 = s.match(/^(\d{4})[.\-/](\d{1,2})[.\-/](\d{1,2})$/);
    if (dotted4) {
        const year = Number(dotted4[1]);
        const month = Number(dotted4[2]);
        const day = Number(dotted4[3]);
        if (isValidYmdParts(year, month, day)) {
            return toYmdString(year, month, day);
        }
    }
    const dotted2 = s.match(/^(\d{2})[.\-/](\d{1,2})[.\-/](\d{1,2})$/);
    if (dotted2) {
        const year = 2000 + Number(dotted2[1]);
        const month = Number(dotted2[2]);
        const day = Number(dotted2[3]);
        if (isValidYmdParts(year, month, day)) {
            return toYmdString(year, month, day);
        }
    }
    const digitsOnly = s.replace(/\D/g, '');
    const from8 = parseYyyyMmDdDigits(digitsOnly);
    if (from8) {
        return from8;
    }
    const from6 = parseYyMmDdDigits(digitsOnly);
    if (from6) {
        return from6;
    }
    const parsed = new Date(s);
    if (!Number.isNaN(parsed.getTime())) {
        return parsed.toISOString().slice(0, 10);
    }
    return '';
};

/** 2026-06-01 / 20260601 / 260601 → 260601 (YYMMDD) */
export const toYyMmDdCompactValue = (raw) => {
    const html = toHtmlDateValue(raw);
    if (!html || !/^\d{4}-\d{2}-\d{2}$/.test(html)) {
        const digits = String(raw ?? '').replace(/\D/g, '');
        if (/^\d{6}$/.test(digits)) {
            return digits;
        }
        return '';
    }
    return `${html.slice(2, 4)}${html.slice(5, 7)}${html.slice(8, 10)}`;
};

export const formatStoredDateValue = (htmlDateValue) => String(htmlDateValue ?? '').trim();
